import request from '@/utils/request'

// 分页查询推送日志
export function reqPushLogPage(data) {
    return request({
        url: '/education/message-push-log/page',
        method: 'post',
        data
    })
}

// 查询推送日志详情
export function reqPushLogDetail(id) {
    return request({
        url: '/education/message-push-log/' + id,
        method: 'get'
    })
}

// 重新推送单条
export function reqPushLogRetry(id) {
    return request({
        url: '/education/message-push-log/retry/' + id,
        method: 'post'
    })
}

// 批量重新推送
export function reqPushLogBatchRetry(ids) {
    return request({
        url: '/education/message-push-log/batch-retry',
        method: 'post',
        data: ids
    })
}

// 测试推送（传入openid和模板参数）
export function reqTestPush(data) {
    return request({
        url: '/education/message-push-log/test-push',
        method: 'post',
        data
    })
}

// 批量删除推送日志
export function reqBatchDelete(ids) {
    return request({
        url: '/education/message-push-log/batch-delete',
        method: 'post',
        data: ids
    })
}
